import { get } from '@/ajax'

export interface IGetMallConfigCodeParams {
  /** 模板code */
  code: string
  /** 租户ID */
  account: string
  /** 查询个人信息时指定用户 */
  user_id?: boolean
  /** 属性code */
  property_code?: string
}

/**
 * @summary 根据模板code获取租户配置信息
 * */
export const getMallConfigCode = (params: IGetMallConfigCodeParams) => get('/mall-config-ms/v1/config-account/ns-code', params)
